import * as React from 'react';
import { P } from '../../../designSystem/typography/Body';
import { clientAccessHelper } from '../../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../../_pageWrappers/MemberPageWrapper';
import { LearningModuleContent } from '../../_components/learning/LearningModuleContent';

export function LearningModulePage (): JSX.Element
{
    const [moduleTitle, setModuleTitle] = React.useState('');

    return (
        <MemberPageWrapper
            selectedMenuItemKey={'learning'}
            breadCrumbs={[
                {text:'Opslagsværket', url:'/learning'},
                ...(moduleTitle ? [{text:moduleTitle, url:''}] : [])
            ]}>
            <LearningModulePageContent onModuleTitleChanged={setModuleTitle} />
        </MemberPageWrapper>
    );
}

type LearningModulePageContentProps = {
    onModuleTitleChanged:(title:string) => void,
}

function LearningModulePageContent (props:LearningModulePageContentProps): JSX.Element
{
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewCustomFormAnswerList']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return <LearningModuleContent onModuleTitleChanged={props.onModuleTitleChanged} />;
}